// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    organization: {
        id: "apps.shared.hooks.organization",
        description: "Organization.",
        defaultMessage: "Organization",
    },
    lensFolder: {
        id: "apps.shared.hooks.lensFolder",
        description: "Lens folder.",
        defaultMessage: "Lens Folder",
    },
    lensFolderLensCreatorRoleLensDeletionError: {
        id: "apps.shared.hooks.lensFolderLensCreatorRoleLensDeletionError",
        description: "Lens folder lens creator role lens deletion error.",
        defaultMessage: "You are not permitted to delete this lens because you are a Lens Folder Creator.",
    },
    lensAdAccountDistributionLensDeletionError: {
        id: "apps.shared.hooks.lensAdAccountDistributionLensDeletionError",
        description: "Lens ad account distribution lens deletion error.",
        defaultMessage: "This lens cannot be deleted because it is being used in one or more of your Ad Accounts.",
    },
});
